import { Icon } from "@/components/ui/Icon";
import { useNotificationPrefs } from "@/hooks/useNotificationPrefs";
import { isOn, withToggle } from "@/lib/notificationPrefs";
import { t } from "@/lib/strings";

// Rendered inside the SettingsPage "Benachrichtigungen" Section (which supplies
// the title + description), so this renders only the matrix table + the
// directed-pierce toggle. In-app is always on in slice 1 (shown disabled-checked);
// the email column is the live control.
export function NotificationPrefsSection() {
  const { query, save } = useNotificationPrefs();
  const prefs = query.data;

  if (query.isLoading || !prefs) {
    return <div style={{ color: "var(--ink-3)", fontSize: 13 }}>{t.loading}</div>;
  }

  const toggleEmail = (reason: string, value: boolean) =>
    save.mutate(withToggle(prefs, reason, "email", value));
  const toggleDirected = (value: boolean) =>
    save.mutate({ ...prefs, always_notify_directed: value });

  return (
    <div>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ color: "var(--ink-3)", textAlign: "left" }}>
            <th style={{ padding: "6px 8px" }} />
            <th style={{ padding: "6px 8px", width: 80 }}>{t.notifPrefsColInApp}</th>
            <th style={{ padding: "6px 8px", width: 80 }}>{t.notifPrefsColEmail}</th>
          </tr>
        </thead>
        <tbody>
          {prefs.reasons.map((reason) => (
            <tr key={reason} style={{ borderTop: "1px solid var(--hairline-soft)" }}>
              <td style={{ padding: "8px", color: "var(--ink-1)" }}>
                {t.notifReasonLabels[reason] ?? reason}
              </td>
              <td style={{ padding: "8px" }}>
                <input type="checkbox" checked readOnly disabled />
              </td>
              <td style={{ padding: "8px" }}>
                {prefs.locked?.[reason]?.email ? (
                  <span
                    style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
                    title={t.notifLockedByAdmin}
                  >
                    <input type="checkbox" checked readOnly disabled />
                    <Icon name="lock" size={12} color="var(--ink-4)" />
                  </span>
                ) : (
                  <input
                    type="checkbox"
                    checked={isOn(prefs, reason, "email")}
                    onChange={(e) => toggleEmail(reason, e.target.checked)}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <label
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          marginTop: 14,
          fontSize: 13,
          color: "var(--ink-1)",
        }}
      >
        <input
          type="checkbox"
          checked={prefs.always_notify_directed}
          onChange={(e) => toggleDirected(e.target.checked)}
        />
        {t.notifPrefsDirected}
      </label>
    </div>
  );
}
